module.exports = __webpack_public_path__ + "img/shocked.93ac4b7f.png";